import { useEffect, useState } from "react";

const useSessionCouponCode = () => {
  const [couponCode, setCouponCode] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const storedCouponCode = sessionStorage.getItem("couponCode");
    if (storedCouponCode) {
      setCouponCode(storedCouponCode);
      setIsLoading(true);
    }
  }, []);

  return {
    couponCode,
    isLoading,
  };
};

export default useSessionCouponCode;
